import React from 'react';
import '../statics/stylesheet.css';
import '../statics/gallery.css';

class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      filteredData: [],
      displayedItems: 9,
      selectedItem: null,
      showModal: false,
      showImageModal: false,
      selectedImage: null,
      searchTerm: '',
      showSuggestions: false,
      suggestions: [],
      selectedYear: '',
      selectedBrand: '',
      availableYears: [],
      availableBrands: []
    };
  }

  componentDidMount() {
    this.fetchGalleryData();
    window.scrollTo(0, 0);
  }

  fetchGalleryData = () => {
    const formData = new FormData();
    formData.append('action', 'get_list');
    
    fetch('https://www.soratwheels.ca/apii/gallery_list.php', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(result => {
        const data = result.data || [];
        this.setState({
          data: data,
          filteredData: [],
          loading: false
        });
        this.extractYearsAndBrands(data);
      })
      .catch(error => {
        console.error('Error fetching gallery data:', error);
        this.setState({ loading: false });
      });
  }

  extractYearsAndBrands = (data) => {
    const brands = new Set();
    
    data.forEach(item => {
      const vehicleParts = item.vehicle.split(' ');
      if (vehicleParts.length > 1) {
        const brand = vehicleParts[1];
        brands.add(brand);
      }
    });

    const sortedBrands = Array.from(brands).sort();
    this.setState({ availableBrands: sortedBrands });
  }

  handleBrandChange = (event) => {
    const selectedBrand = event.target.value;
    this.setState({ 
      selectedBrand,
      selectedYear: '',
      availableYears: []
    });

    if (selectedBrand) {
      const yearsForBrand = new Set();
      
      this.state.data.forEach(item => {
        const vehicleParts = item.vehicle.split(' ');
        const year = vehicleParts[0];
        const brand = vehicleParts[1];
        
        if (brand === selectedBrand && year && !isNaN(year) && year.length === 4) {
          yearsForBrand.add(year);
        }
      });

      const sortedYears = Array.from(yearsForBrand).sort((a, b) => b - a);
      this.setState({ availableYears: sortedYears });
    }

    this.applyFilters('', selectedBrand);
  }

  handleYearChange = (event) => {
    const selectedYear = event.target.value;
    this.setState({ selectedYear });
    this.applyFilters(selectedYear, this.state.selectedBrand);
  }

  applyFilters = (year, brand) => {
    let filtered = this.state.data;

    if (brand) {
      filtered = filtered.filter(item => {
        const vehicleParts = item.vehicle.split(' ');
        return vehicleParts.length > 1 && vehicleParts[1] === brand;
      });
    }

    if (year) {
      filtered = filtered.filter(item => {
        const vehicleParts = item.vehicle.split(' ');
        return vehicleParts[0] === year;
      });
    }

    this.setState({
      filteredData: year || brand ? filtered : [],
      displayedItems: 9
    });
  }

  clearFilters = () => {
    this.setState({
      selectedYear: '',
      selectedBrand: '',
      availableYears: [],
      filteredData: [],
      displayedItems: 9,
      searchTerm: '',
      suggestions: [],
      showSuggestions: false
    });
  }

  loadMore = () => {
    this.setState(prevState => ({
      displayedItems: prevState.displayedItems + 9
    }));
  }

  openModal = (item) => {
    this.setState({
      selectedItem: item,
      showModal: true
    });
  }

  closeModal = () => {
    this.setState({
      selectedItem: null,
      showModal: false
    });
  }

  openImageModal = (image) => {
    this.setState({
      showImageModal: true,
      selectedImage: image
    });
  }

  closeImageModal = () => {
    this.setState({
      showImageModal: false,
      selectedImage: null
    });
  }

  getFirstImage = (imageString) => {
    if (!imageString) return '';
    const images = imageString.split(',');
    return images[0].trim();
  }

  getAllImages = (imageString) => {
    if (!imageString) return [];
    return imageString.split(',').map(img => img.trim());
  }

  handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    this.setState({ searchTerm });

    if (searchTerm.length >= 3) {
      const suggestions = this.state.data.filter(item =>
        item.vehicle.toLowerCase().includes(searchTerm.toLowerCase())
      ).slice(0, 10); // Show max 10 suggestions
      
      this.setState({
        suggestions,
        showSuggestions: true
      });
    } else {
      this.setState({
        suggestions: [],
        showSuggestions: false,
        filteredData: [],
        displayedItems: 9
      });
    }
  }

  selectSuggestion = (vehicle) => {
    const filteredData = this.state.data.filter(item =>
      item.vehicle.toLowerCase().includes(vehicle.toLowerCase())
    );
    
    this.setState({
      searchTerm: vehicle,
      filteredData,
      showSuggestions: false,
      displayedItems: 9
    });
  }

  clearSearch = () => {
    this.setState({
      searchTerm: '',
      filteredData: [],
      suggestions: [],
      showSuggestions: false,
      displayedItems: 9
    });
  }

  renderGalleryItem = (item) => {
    const firstImage = this.getFirstImage(item.image);
    
    return (
      <div key={item.idgallery} className="gallery-item">
        <h3 className="gallery-vehicle-title">{item.vehicle}</h3>
        <div className="gallery-image-container">
          <img 
            src={`https://www.soratwheels.ca/gallery/${firstImage}`}
            alt={item.vehicle}
            className="gallery-image"
            onError={(e) => {
              e.target.src = window.baseUrl + '/media/soratimg.jpg';
            }}
          />
        </div>
        <button 
          className="gallery-more-details-btn"
          onClick={() => this.openModal(item)}
        >
          More Details
        </button>
      </div>
    );
  }

  renderModal = () => {
    const { selectedItem } = this.state;
    if (!selectedItem) return null;

    const allImages = this.getAllImages(selectedItem.image);

    return (
      <div className="gallery-modal-overlay" onClick={this.closeModal}>
        <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="gallery-modal-close" onClick={this.closeModal}>×</button>
          
          <h2 className="gallery-modal-title">{selectedItem.vehicle}</h2>
          
          <div className="gallery-modal-images">
            {allImages.map((image, index) => (
              <img 
                key={index}
                src={`https://www.soratwheels.ca/gallery/${image}`}
                alt={`${selectedItem.vehicle} ${index + 1}`}
                className="gallery-modal-image"
                onClick={() => this.openImageModal(`https://www.soratwheels.ca/gallery/${image}`)}
                onError={(e) => {
                  e.target.src = window.baseUrl + '/media/soratimg.jpg';
                }}
              />
            ))}
          </div>

          <div className="gallery-modal-details">
            <div className="gallery-modal-column">
              <h3>Tire Information</h3>
              <p><strong>Brand:</strong> {selectedItem.tires_brand ? selectedItem.tires_brand : 'N/A'}</p>
              <p><strong>Model:</strong> {selectedItem.tires_model ? selectedItem.tires_model : 'N/A'}</p>
              <p><strong>Size:</strong> {selectedItem.tire_size ? selectedItem.tire_size : 'N/A'}</p>
              {selectedItem.tire_size2 && <p><strong>Size 2:</strong> {selectedItem.tire_size2}</p>}
              {selectedItem.tires_sku && <p><strong>SKU:</strong> {selectedItem.tires_sku}</p>}
              {selectedItem.tires2_sku && <p><strong>SKU 2:</strong> {selectedItem.tires2_sku}</p>}
            </div>
            
            <div className="gallery-modal-column">
              <h3>Wheel Information</h3>
              <p><strong>Brand:</strong> {selectedItem.wheels_brand ? selectedItem.wheels_brand : 'N/A'}</p>
              <p><strong>Model:</strong> {selectedItem.wheels_model ? selectedItem.wheels_model : 'N/A'}</p>
              <p><strong>Width:</strong> {selectedItem.wheels_width ? selectedItem.wheels_width : 'N/A'}</p>
              {selectedItem.wheels_width2 && <p><strong>Width 2:</strong> {selectedItem.wheels_width2}</p>}
              <p><strong>Offset:</strong> {selectedItem.offset ? selectedItem.offset : 'N/A'}</p>
              {selectedItem.offset2 && <p><strong>Offset 2:</strong> {selectedItem.offset2}</p>}
              <p><strong>Bolt Pattern:</strong> {selectedItem.boltpattern ? selectedItem.boltpattern : 'N/A'}</p>
              {selectedItem.boltpattern2 && <p><strong>Bolt Pattern 2:</strong> {selectedItem.boltpattern2}</p>}
              <p><strong>Center Bore:</strong> {selectedItem.center_bore ? selectedItem.center_bore : 'N/A'}</p>
              {selectedItem.center_bore2 && <p><strong>Center Bore 2:</strong> {selectedItem.center_bore2}</p>}
              {selectedItem.wheels_sku && <p><strong>SKU:</strong> {selectedItem.wheels_sku}</p>}
              {selectedItem.wheels2_sku && <p><strong>SKU 2:</strong> {selectedItem.wheels2_sku}</p>}
            </div>
          </div>

          {selectedItem.note && (
            <div className="gallery-modal-note">
              <h3>Note</h3>
              <p>{selectedItem.note}</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderImageModal = () => {
    return (
      <div className="gallery-image-modal-overlay" onClick={this.closeImageModal}>
        <div className="gallery-image-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="gallery-image-modal-close" onClick={this.closeImageModal}>×</button>
          <img 
            src={this.state.selectedImage}
            alt="Full size"
            className="gallery-image-modal-img"
          />
        </div>
      </div>
    );
  }

  render() {
    const { 
      loading, data, filteredData, displayedItems, searchTerm, showSuggestions, suggestions,
      selectedYear, selectedBrand, availableYears, availableBrands
    } = this.state;

    if (loading) {
      return (
        <div className="gallery-loading">
          <div className="content-divLength">
            {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
              <img src={window.host + '/statics/img/loading.svg'}/> :
              <img src={window.host + '/statics/img/loading.gif'}/>}
          </div>
        </div>
      );
    }

    const currentData = filteredData.length > 0 || selectedYear || selectedBrand || searchTerm ? filteredData : data;
    const itemsToShow = currentData.slice(0, displayedItems);
    const hasMore = displayedItems < currentData.length;

    return (
      <div className="gallery-container">
        <h1 className="gallery-main-title">Vehicle Gallery</h1>
        
        <div className="gallery-filters-container">
          <div className="gallery-dropdowns">
            <h5 className="filter_label">Filters:</h5>
            <select 
              className="gallery-dropdown"
              value={this.state.selectedBrand}
              onChange={this.handleBrandChange}
            >
              <option value="">Select Brand</option>
              {this.state.availableBrands.map(brand => (
                <option key={brand} value={brand}>{brand}</option>
              ))}
            </select>

            <select 
              className="gallery-dropdown"
              value={this.state.selectedYear}
              onChange={this.handleYearChange}
              disabled={!this.state.selectedBrand}
            >
              <option value="">Select Year</option>
              {this.state.availableYears.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>

            {(this.state.selectedYear || this.state.selectedBrand) && (
              <button className="gallery-clear-filters" onClick={this.clearFilters}>
                Clear Filters
              </button>
            )}
          </div>
        </div>
        
        <div className="gallery-grid">
          {itemsToShow.map(item => this.renderGalleryItem(item))}
        </div>

        {itemsToShow.length === 0 && (selectedYear || selectedBrand || searchTerm) && (
          <div className="gallery-no-results">
            <p>No vehicles found matching your criteria</p>
          </div>
        )}

        {hasMore && (
          <div className="gallery-load-more-container">
            <button className="gallery-load-more-btn" onClick={this.loadMore}>
              Load More
            </button>
          </div>
        )}

        {this.state.showModal && this.renderModal()}
        {this.state.showImageModal && this.renderImageModal()}
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js